module.exports = __webpack_public_path__ + "img/product-complaint-solve-bg-icon.a0e1d37b.png";